import { config } from "@/config";
import * as Frigade from "@frigade/react";
import OnboardingFlow from "./OnboardingFlow";

const OnboardingManageAssessmentsHint = () => {
    return (
      <OnboardingFlow>
        <Frigade.Tour
          flowId={config.frigade.flows.manageAssessmentsHint}
          defaultOpen={true}
          side="right"
        />
      </OnboardingFlow>
    );
};

export default OnboardingManageAssessmentsHint;